import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AlertController, LoadingController } from "@ionic/angular";
import { Router } from "@angular/router";
import { MatChipInputEvent } from "@angular/material/chips";
import { ENTER, COMMA, SPACE } from "@angular/cdk/keycodes";
import { DateAdapter } from "@angular/material/core";
import { DateFormat } from "../report/setdate";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-resend",
  templateUrl: "./resend.component.html",
  styleUrls: ["./resend.component.scss"],
  providers: [{ provide: DateAdapter, useClass: DateFormat }],
})
export class ResendComponent implements OnInit {
  formResend: FormGroup;
  phone: any = "";
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  fruits = [];

 

  constructor(
    private builder: FormBuilder,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private router: Router,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.initialCreateFomrResend();
    dateAdapter.setLocale("en-GB");
  }

  ngOnInit() {}

  ionViewDidEnter() {
    this.initialCreateFomrResend();
  }

  initialCreateFomrResend() {
    this.formResend = this.builder.group({
      companyName: [""],
      phoneNumber: [""],
      idCardNumber: [""],
      taxId: [""],
      resendDateStart: [new Date(), [Validators.required]],
      resendDateTo: [new Date(), [Validators.required]],
    });
  }

  onChangeEventDateStart(e) {
    const checkData: Date = e.target.value;
    const thisDate = new Date();
    console.log(
      checkData.getFullYear() >= thisDate.getFullYear() &&
        checkData.getMonth() >= thisDate.getMonth() &&
        checkData.getDate() > thisDate.getDate()
    );
    if (
      checkData.getFullYear() >= thisDate.getFullYear() &&
      checkData.getMonth() >= thisDate.getMonth() &&
      checkData.getDate() >= thisDate.getDate()
    ) {
      this.formResend.controls["resendDateStart"].setValue(new Date());
    }
  }

  onChangeEventDateTo(e) {
    const checkData: Date = e.target.value;
    const thisDate = new Date();
    console.log(
      checkData.getFullYear() >= thisDate.getFullYear() &&
        checkData.getMonth() >= thisDate.getMonth() &&
        checkData.getDate() > thisDate.getDate()
    );
    if (
      checkData.getFullYear() >= thisDate.getFullYear() &&
      checkData.getMonth() >= thisDate.getMonth() &&
      checkData.getDate() >= thisDate.getDate()
    ) {
      this.formResend.controls["resendDateTo"].setValue(new Date());
    }
  }

  async onSubmit() {
    // console.log(this.formResend.value.companyName);
    // return;
    let isConfirm: boolean = false;
    if (!isConfirm) {
      if (
        this.formResend.value.companyName === "" &&
        this.formResend.value.phoneNumber === "" &&
        this.formResend.value.idCardNumber === "" &&
        this.formResend.value.taxId === ""
      ) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: "ต้องระบุข้อมูลอย่างใดอย่างหนึ่ง",
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {},
            },
          ],
        });

        await alert.present();
      } else {
        isConfirm = true;
      }
    } else {
      isConfirm = true;
    }
    if (isConfirm) {
      const value = {
        phoneNumber: this.fruits,
        ...this.formResend.value,
      };
      const navigationExtras = {
        queryParams: {
          formResend: JSON.stringify(value),
        },
      };
      this.router.navigate(["resend-select-taxinvoice"], navigationExtras);
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || "").trim()) {
      this.fruits.push(value.trim());
    }

    if (input) {
      input.value = "";
    }
  }

  remove(fruit): void {
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  onKeyUpEvent(e) {
    const last = e.target.value.slice(-1);
    if (isNaN(last)) {
      e.target.value = e.target.value.slice(0, -1);
    }
    if (e.target.value.length > 10) {
      e.target.value = e.target.value.slice(0, -1);
    }
  }
  checkphone(e) {
    e.target.value= e.target.value.match(/[0-9]*/)[0];

  }
}
